import { render, staticRenderFns } from "./settings-send.vue?vue&type=template&id=6926e302&"
import script from "./settings-send.vue?vue&type=script&lang=js&"
export * from "./settings-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports